export default __webpack_public_path__ + "static/media/nav-metrics-outline.989b072c.svg";